import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Performance Max on the YouTube watch page (mobile): square image played as
 * an in-stream ad in the player, with the advertiser row and CTA below.
 */
@Component({
    selector: 'app-pmax-youtube-mobile-03',
    imports: [
        CommonModule,
        MobileFrameComponent,
    ],
    templateUrl: './youtube-mobile-03.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-mobile-03.component.scss',
    ]
})
export class PmaxYoutubeMobile03PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the 1:1 square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** Skeleton chip row under the video. */
  readonly chips = [0, 1, 2, 3];

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
